import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const QrCodeIcon = (props: SvgProps) => (
  <Svg
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.25 6.5A1.5 1.5 0 0 1 6.75 5h6a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-6ZM5.25 19.5a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-6ZM18.25 6.5a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-6Z"
    />
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.25 9h1v1h-1V9ZM9.25 22h1v1h-1v-1ZM22.25 9h1v1h-1V9ZM18.25 18h1v1h-1v-1ZM18.25 26h1v1h-1v-1ZM26.25 18h1v1h-1v-1ZM26.25 26h1v1h-1v-1ZM22.25 22h1v1h-1v-1Z"
    />
  </Svg>
);
export default QrCodeIcon;
